/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenInvitationConfigCto } from '../../models/open-invitation-config-cto';
import { OpenInvitationConfigUpdateCto } from '../../models/open-invitation-config-update-cto';

export interface UpdateAsync$Plain$Params {
  companyGuid: string;
  documentId: string;
      body?: OpenInvitationConfigUpdateCto
}

export function updateAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
  const rb = new RequestBuilder(rootUrl, updateAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OpenInvitationConfigCto>;
    })
  );
}

updateAsync$Plain.PATH = '/open-invitation-config/company/{companyGuid}/document/{documentId}';
